import { apiClient } from "@/service/ApiClient";

export interface PlaceData {
    id: number
    teamId: number
    name: string
}

/** 경기장 목록 */
const getPlaceList = async () =>
    apiClient
        .get<PlaceData[]>('/place/list')
        .then(res => res.data)

/** 경기장 등록 */
const savePlace = async (data: Partial<PlaceData>) =>
    apiClient
        .post<PlaceData>('/place', data)
        .then(res => res.data)

/** 경기장 삭제 */
const deletePlace = async (id: number) =>
    apiClient.delete(`/place/${id}`)

const PlaceService = {
    getPlaceList,
    savePlace,
    deletePlace
}

export default PlaceService
